<template>
  <v-app class="app-dashboard">
    <v-container fluid class="pa-6">
      <!-- KPI Cards -->
      <v-row dense class="mb-4">
        <!-- Meta Total -->
        <v-col cols="12" sm="6" md="3" class="kpi-col-5">
          <v-card class="kpi-card pa-5" outlined>
            <v-skeleton-loader
              v-if="loading"
              type="list-item-avatar-two-line"
            ></v-skeleton-loader>
            <div v-else class="d-flex justify-space-between align-center">
              <div>
                <p class="mb-1 text-uppercase caption grey--text">
                  Meta Total
                </p>
                <div class="display-1 font-weight-bold">
                  {{ cards.total_meta }}
                </div>
              </div>
              <v-avatar color="primary" size="56">
                <v-icon color="white">mdi-flag-checkered</v-icon>
              </v-avatar>
            </div>
          </v-card>
        </v-col>

        <!-- Meta Efetivada -->
        <v-col cols="12" sm="6" md="3" class="kpi-col-5">
          <v-card class="kpi-card pa-5" outlined>
            <v-skeleton-loader
              v-if="loading"
              type="list-item-avatar-two-line"
            ></v-skeleton-loader>
            <div v-else class="d-flex justify-space-between align-center">
              <div>
                <p class="mb-1 text-uppercase caption grey--text">
                  Meta Efetivada
                </p>
                <div class="display-1 font-weight-bold success--text">
                  {{ cards.total_cadastro }}
                </div>
              </div>
              <v-avatar color="success" size="56">
                <v-icon color="white">mdi-check-decagram</v-icon>
              </v-avatar>
            </div>
          </v-card>
        </v-col>

        <!-- % Realizado -->
        <v-col cols="12" sm="6" md="3" class="kpi-col-5">
          <v-card class="kpi-card pa-5" outlined>
            <v-skeleton-loader
              v-if="loading"
              type="list-item-two-line"
            ></v-skeleton-loader>
            <template v-else>
              <div class="d-flex justify-space-between align-center mb-3">
                <div>
                  <p class="mb-1 text-uppercase caption grey--text">
                    % Realizado
                  </p>
                  <div class="headline font-weight-bold">
                    {{ cards.total_percentual }}%
                  </div>
                </div>
                <v-icon color="primary" large>mdi-chart-arc</v-icon>
              </div>
              <v-progress-linear
                rounded
                height="10"
                color="primary"
                :value="cards.total_percentual"
              ></v-progress-linear>
            </template>
          </v-card>
        </v-col>

        <!-- Cad. Quebrados -->
        <v-col cols="12" sm="6" md="3" class="kpi-col-5">
          <v-card
            class="kpi-card kpi-card--clickable pa-5"
            outlined
            @click="getReportQuebrados(select_equipe)"
          >
            <v-skeleton-loader
              v-if="loading"
              type="list-item-avatar-two-line"
            ></v-skeleton-loader>
            <div v-else class="d-flex justify-space-between align-center">
              <div>
                <p class="mb-1 text-uppercase caption grey--text">
                  Cad. Quebrados
                </p>
                <div class="display-1 font-weight-bold error--text">
                  {{ cards.total_quebra }}
                </div>
              </div>
              <v-avatar color="error" size="56">
                <v-icon color="white">mdi-alert-circle</v-icon>
              </v-avatar>
            </div>
          </v-card>
        </v-col>

        <!-- Análise Detalhada -->
        <v-col cols="12" sm="6" md="3" class="kpi-col-5">
          <v-card
            class="kpi-card kpi-card--clickable pa-5"
            outlined
            @click="$router.push({ name: 'dashboard_equipe' })"
          >
            <div class="d-flex justify-space-between align-center">
              <div>
                <p class="mb-1 text-uppercase caption grey--text">
                  Análise Detalhada
                </p>
                <div class="subtitle-1 font-weight-bold primary--text">
                  Ver mais análises
                </div>
              </div>
              <v-avatar color="info" size="56">
                <v-icon color="white">mdi-chart-bar</v-icon>
              </v-avatar>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <!-- Barra de Filtros -->
      <v-card class="filter-card pa-4 mb-4" outlined>
        <v-row align="center" dense>
          <v-col cols="12" sm="4" md="3">
            <v-select
              v-model="select_equipe"
              :items="selects.candidatos.items"
              :disabled="selects.candidatos.ativado"
              @change="
                buscarAssessores();
                getMetas(select_equipe);
                buscarTotais();
              "
              outlined
              rounded
              dense
              label="Equipe"
              item-value="idcandidato"
              item-text="nome_completo"
              hide-details
            ></v-select>
          </v-col>
          <v-col cols="12" sm="4" md="3">
            <v-select
              v-model="select_meta"
              :items="selects.metas.items"
              @change="buscarAssessores(); buscarTotais()"
              outlined
              rounded
              dense
              label="Tipo de Meta"
              item-value="idmeta"
              item-text="descricao"
              hide-details
            ></v-select>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="auto">
            <v-btn
              color="warning"
              small
              rounded
              class="mr-2"
              title="Apuração por Metas"
              @click="getReportApuracaoMeta(select_equipe)"
            >
              <v-icon left small>mdi-account-group</v-icon>
              Apuração Metas
            </v-btn>
            <v-btn
              color="warning"
              small
              rounded
              class="mr-2"
              title="Apuração por Assessor"
              @click="getReportApuracaoAssessor(select_equipe)"
            >
              <v-icon left small>mdi-tray-full</v-icon>
              Apuração Assessor
            </v-btn>
            <v-btn
              color="primary"
              small
              rounded
              title="Atualizar os Dados"
              @click="atualizarDados()"
            >
              <v-icon left small>mdi-refresh</v-icon>
              Atualizar
            </v-btn>
          </v-col>
        </v-row>
      </v-card>

      <!-- Tabela de Assessores -->
      <v-card class="table-card" outlined>
        <v-data-table
          :headers="headers"
          :items="itemsWithIndex"
          :search="search"
          :items-per-page="-1"
          :fixed-header="true"
          height="70vh"
        >
          <template v-slot:top>
            <v-toolbar flat class="px-4">
              <v-toolbar-title class="font-weight-medium">
                Lista de Assessores
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Pesquisar"
                single-line
                hide-details
                dense
                rounded
                outlined
                style="max-width: 300px"
              ></v-text-field>
            </v-toolbar>
          </template>

          <template v-slot:item.percentual="{ item }">
            <v-chip
              small
              :color="getPercentColor(item.percentual)"
              dark
            >
              {{ item.percentual }}%
            </v-chip>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-btn
              icon
              small
              color="primary"
              @click="getReportAssessor(item.id)"
            >
              <v-icon small>mdi-printer</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
import DashboardAPI from "./../../api/dashboard";
import AclAPI from "./../../api/acl";
import VueLazyInput from "vue-lazy-input";
import Vue from "vue";

Vue.use(VueLazyInput);

export default {
  data() {
    return {
      loading: true,
      dialog: false,
      search: "",
      cards: {
        total_meta: 0,
        total_cadastro: 0,
        total_percentual: 0,
        total_quebra: 0,
      },
      select_equipe: 0,
      select_meta: 0,
      selects: {
        candidatos: {
          ativado: false,
          value: 0,
          items: [],
        },
        metas: {
          value: 0,
          items: [],
        },
      },
      headers: [
        { text: "Indice", value: "index" },
        {
          text: "Equipe",
          align: "start",
          value: "equipe",
        },
        {
          text: "Nome Completo",
          align: "start",
          value: "nome_completo",
        },
        { text: "Meta", value: "total_geral_meta" },
        { text: "Total de Cadastrados", value: "total_cadastrado" },
        { text: "Percentual Meta", value: "percentual" },
        { text: "Ações", value: "actions", sortable: false },
      ],
      desserts: [],
    };
  },
  computed: {
    setarEquipe() {
      const equipe = localStorage.getItem("equipe");
      return equipe;
    },
    itemsWithIndex() {
      return this.desserts.map((items, index) => ({
        ...items,
        index: index + 1,
      }));
    },
  },
  watch: {
    buscaCandidatos() {
      this.select_equipe = this.setarEquipe;
    },
  },

  created() {
    this.Helpers.verificarToken();
    this.buscaCandidatos();
    setTimeout(() => {
      this.setEquipe();
    }, 200);
    setTimeout(() => {
      this.buscarAssessores();
      this.buscarTotais();
    }, 300);
  },
  methods: {
    getPercentColor(percentual) {
      const val = parseFloat(percentual) || 0;
      if (val >= 100) return "success";
      if (val >= 50) return "warning";
      return "error";
    },

    buscaCandidatos() {
      const headers = this.Helpers.iniciarRequisicao();
      AclAPI.getCandidatos(headers)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          this.selects.candidatos.items = [];

          if (response.status == 200) {
            this.selects.candidatos.items = response.data.candidatos;

            let objCandidato = {
              idcandidato: "null",
              nome_completo: "TODOS",
              chapa: 0,
            };

            this.selects.candidatos.items.push(objCandidato);
          }
        })
        .catch(() => {
          this.Helpers.logout();
        });
    },
    buscarTotais() {
      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        equipe: this.select_equipe,
        meta: this.select_meta,
      };

      DashboardAPI.getTotais(headers, params)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          this.cards.total_meta = response.data.totais[0].total_geral_meta;
          this.cards.total_cadastro = response.data.totais[0].total_cadastrado;
          this.cards.total_percentual = response.data.totais[0].percentual;
          this.cards.total_quebra = response.data.quebra[0].total;
          this.loading = false;
        })
        .catch(() => {
          this.$store.dispatch("loading/habilitarLoading", false);
          this.loading = false;
          this.Helpers.logout();
        });
    },
    buscarAssessores() {
      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        equipe: this.select_equipe,
        meta: this.select_meta,
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        DashboardAPI.getAssessores(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            this.desserts = response.data.assessores;
          })
          .catch(() => {
            this.$store.dispatch("loading/habilitarLoading", false);
            this.Helpers.logout();
          })
      );
    },
    getMetas(equipe) {
      const headers = this.Helpers.iniciarRequisicao();
      const params = {
        equipe: equipe,
      };

      AclAPI.getMetas(headers, params)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          this.selects.metas.items = [];

          if (response.status == 200) {
            this.selects.metas.items = response.data.metas;

            let objMetas = {
              idmeta: "null",
              descricao: "TODAS",
            };

            this.selects.metas.items.push(objMetas);
            this.select_meta = "null";
          }
        })
        .catch(() => {
          this.Helpers.logout();
        });
    },
    getReportAssessor(id) {
      const equipe = localStorage.getItem("id");
      let url = "relatorio_assessores?id=" + id + "&id_cd=" + equipe;
      window.open(process.env.VUE_APP_URL_BASE + "/api/" + url, "_blank");
    },
    getReportQuebrados(id) {
      let url = "relatorio_quebrados?id=" + id + "&meta=" + this.select_meta;
      window.open(process.env.VUE_APP_URL_BASE + "/api/" + url, "_blank");
    },
    getReportApuracaoAssessor(id) {
      let url =
        "relatorio_apuracao?equipe=" +
        id +
        "&meta=" +
        this.select_meta +
        "&tipo=" +
        2 +
        "&tipo_apuracao=" +
        2;
      window.open(process.env.VUE_APP_URL_BASE + "/api/" + url, "_blank");
    },
    getReportApuracaoMeta(id) {
      let url =
        "relatorio_apuracao?equipe=" +
        id +
        "&meta=" +
        this.select_meta +
        "&tipo=" +
        1 +
        "&tipo_apuracao=" +
        2;
      window.open(process.env.VUE_APP_URL_BASE + "/api/" + url, "_blank");
    },

    setEquipe() {
      const equipe = localStorage.getItem("equipe");

      if (equipe != "null") {
        this.select_equipe = parseInt(equipe);
        this.selects.candidatos.ativado = true;
        this.getMetas(equipe);
      } else {
        this.select_equipe = "null";
        this.getMetas("null");
      }
    },
    atualizarDados() {
      this.loading = true;
      this.buscarAssessores();
      this.buscarTotais();
    },
  },
};
</script>

<style scoped>
.app-dashboard {
  background-color: #f4f5f7;
  min-height: 100vh;
}

.kpi-card {
  border-radius: 16px;
  min-height: 130px;
  transition: box-shadow 0.2s;
}

.kpi-card:hover {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.kpi-card--clickable {
  cursor: pointer;
}

.filter-card {
  border-radius: 16px;
}

.table-card {
  border-radius: 16px;
  overflow: hidden;
}

@media (min-width: 960px) {
  .kpi-col-5 {
    flex: 0 0 20%;
    max-width: 20%;
  }
}
</style>
